/**
 * 隐私保护svg
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/7
 */
import React from 'react';

const Secret = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-secret">
    <path d="M847.82 934.428h-671.641c-30.048 0-53.025-22.976-53.025-53.025v-459.545c0-30.048 22.976-53.025 53.025-53.025h671.641c30.048 0 53.025 22.976 53.025 53.025v459.545c0 30.048-22.976 53.025-53.025 53.025zM176.18 404.186c-10.605 0-17.675 7.069-17.675 17.675v459.545c0 10.605 7.069 17.675 17.675 17.675h671.641c10.605 0 17.675-7.069 17.675-17.675v-459.545c0-10.605-7.069-17.675-17.675-17.675h-671.641z"/>
    <path d="M246.879 354.694v-213.865c0-1.767 1.767-15.907 3.535-15.907h521.406c1.767 0 3.535 14.141 3.535 15.907v125.491h35.349v-125.491c0-21.21-17.675-51.258-38.883-51.258h-521.406c-21.21 0-38.883 30.048-38.883 51.258v220.934c0 21.21 17.675 30.048 38.883 30.048z"/>
    <path d="M512 851.355c-14.141 0-28.278-3.535-38.883-12.372l-102.513-79.536c-19.442-15.907-35.349-45.955-35.349-70.7v-176.747c0-30.048 22.976-53.025 53.025-53.025h247.447c30.048 0 53.025 22.976 53.025 53.025v176.747c0 24.745-14.141 54.791-35.349 70.7l-102.513 79.536c-10.605 8.837-24.745 12.372-38.883 12.372zM388.277 492.558c-10.605 0-17.675 7.069-17.675 17.675v176.747c0 14.141 10.605 35.349 21.21 42.42l102.513 79.536c8.837 7.069 24.745 7.069 33.582 0l102.513-79.536c10.605-8.837 21.21-28.278 21.21-42.42v-176.747c0-10.605-7.069-17.675-17.675-17.675h-245.679z"/>
    <path d="M492.924 723.597l-87.485-87.485 24.996-24.996 87.485 87.485-24.996 24.996z"/>
    <path d="M468.323 697.703l124.978-124.978 24.996 24.996-124.978 124.978-24.996-24.996z"/>
  </svg>
};

export default Secret


// WEBPACK FOOTER //
// ./src/svgs/secret.js